import { surfaces } from '@ui/kit/design-tokens';

const hotspotSurface = surfaces.accent.default.__extend("--hotspot-color");
const heading = "_mwhcdtl4j";
const aspectRatio = "_mwa1rn5ckn";
const img = "_mwin9wt8f";
const hotspot = "_mwh1857nbu";

export { aspectRatio, heading, hotspot, hotspotSurface, img };
import "./organism.print.style.linaria.module.css";
//# sourceMappingURL=organism.print.style.js.map
